import {isIntercomAvailable} from './is-intercom-available';

/**
 * This function handles displaying the intercom surveys, there are quite a lot of ways to share an intercom survey
 * this one handles the "share by code" option.
 * @param surveyId is the ID of the survey that intercom gives you once you create a survey and choose the "share by code" option.
 * IMPORTANT: Survey ID's are different for our production and development environments on intercom so make sure to pass the right ID.
 */
export const startIntercomSurvey = (surveyId: number) => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('startSurvey', surveyId);
    return true;
};
